import { useEffect } from "react";

const useFavicon = () => {
  useEffect(() => {
    const env = process.env.REACT_APP_ENV;
    const webUrl = process.env.REACT_APP_WEB_URL;

    // 1. If production, don't change anything
    if (env === "production") return;

    // 2. Determine path based on environment (Test, Pentest, UAT)
    let faviconPath = env === "test" ? `${webUrl}/favicon-red.ico` : `${webUrl}/favicon-orange.ico`;

    // 3. Update standard favicon
    const link: HTMLLinkElement | null = document.querySelector("link[rel~='icon']");
    if (link) {
      link.href = faviconPath;
    }

    // 4. Update Apple touch icon
    const appleTouchLink: HTMLLinkElement | null = document.querySelector(
      "link[rel~='apple-touch-icon']"
    );
    if (appleTouchLink) {
      appleTouchLink.href = faviconPath;
    }
  }, []); // Empty dependency array ensures this runs once on mount
};

export default useFavicon;